import { CSSProperties, ReactNode } from 'react';
import Text from '../text/Text';
import styles from './StatelessCard.module.css';

type StatelessCardProps = {
  text: string;
  Button: ReactNode;
  imageSource: string;
  imageType?: 'bg-image' | 'image';
  imageStyles?: CSSProperties;
};

const StatelessCard = ({
  text,
  Button,
  imageSource,
  imageType = 'image',
  imageStyles,
}: StatelessCardProps) => (
  <div className={styles.wrapper}>
    <div className={styles['flex-2']}>
      <Text style={{ color: 'var(--color-text-gray)' }}>{text}</Text>
      {Button}
    </div>
    <div
      className={`${styles['flex-1']} ${imageType === 'image' ? styles['with-padding'] : ''}`}
    >
      {imageType === 'image' ? (
        <img src={imageSource} alt='' />
      ) : (
        <div style={{ ...imageStyles, background: `url(${imageSource})` }} />
      )}
    </div>
  </div>
);

export default StatelessCard;
